export default __webpack_public_path__ + "static/media/lock.35a2d6ca.svg";